import { CurrenciesApiService } from '../../common/services/currencies.api.service';
import REQUEST_STATUS from '../../common/enums/requestStatus';

export default {
  namespaced: true,
  state: {
    items: [],
    status: REQUEST_STATUS.LOADING,
    defaultCurrency: null,
    activeCurrency: null,
  },
  getters: {
    getForComboBox: state =>
      state.items.map(item => ({
        value: item,
        text: item.id,
      })),
    getCurrencies: state => state.items,
    getCurrency: state => id => state.items.find(curr => curr.id === id),
    getCurrencyIds: state => state.items.map(curr => curr.id),
    getDefaultCurrency: state => state.defaultCurrency,
    getActiveCurrency: state => state.activeCurrency,
  },

  mutations: {
    SET_ITEMS(state, currencies) {
      state.items = currencies;
    },
    SET_DEFAULT_CURRENCY(state, currency) {
      state.defaultCurrency = currency;
    },
    SET_ACTIVE_CURRENCY(state, currency) {
      state.activeCurrency = currency;
    },
    FETCH_REQUEST(state) {
      state.status = REQUEST_STATUS.LOADING;
    },
    FETCH_SUCCESS(state) {
      state.status = REQUEST_STATUS.SUCCESS;
    },
    FETCH_FAIL(state) {
      state.status = REQUEST_STATUS.FAIL;
    },
  },

  actions: {
    fetchAll({ commit, dispatch }) {
      commit('FETCH_REQUEST');

      return CurrenciesApiService.getAll()
        .then(response => {
          const currencies = response.getItems();
          const defaultCurrency = currencies.find(curr => curr.isDefault);

          commit('SET_ITEMS', currencies);
          commit('SET_DEFAULT_CURRENCY', defaultCurrency);
          commit('SET_ACTIVE_CURRENCY', defaultCurrency);
          commit('FETCH_SUCCESS');
        })
        .catch(response => {
          dispatch('handleError', response);
        });
    },

    handleError({ commit }, response) {
      commit('FETCH_FAIL');
      const message = response.getFirstValidationErrorMessage() || response.getMessage();
      this.$app.$alertError(message);
    },
  },
};
